import React from "react";

import { DataInAnyRow } from "components/PageDashboard/ICalFeedsToImportSection/ICalFeedsToImportTable/ICalFeedsToImportTable";
import { ModalWizardStepRenderProps } from "components/ModalWizard/ModalWizard";
import StepBoolean from "components/StepBoolean";

function StepContainsExternallyBookedMeetings({
	...props
}: ModalWizardStepRenderProps<DataInAnyRow>) {
	return (
		<StepBoolean {...props} wizardDataKey="containsExternallyBookedMeetings" />
	);
}

export default StepContainsExternallyBookedMeetings;
